/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

// import styled from 'styled-components';
//
// const StyledDiv = styled.div`
//   padding: 12px 0 0 0;
//   display: flex;
//   justify-content: space-between;
//
//   .nps-message {
//     font-size: 10px;
//     line-height: 1;
//     width: 20%;
//     text-align: center;
//     white-space: nowrap;
//   }
// `;

/**
 * NPS - min / max text を表示します
 * @param {string} txt0 min text
 * @param {string} txt1 max text
 * @param {string} [className=''] optional tag class
 * @return {*} React.node
 * @constructor
 */
const NpsGuide = ({ txt0, txt1, className = '' }) => (
  <>
    <div className="nps-message">{txt0}</div>
    <div className="nps-message">{txt1}</div>
  </>
);

export default NpsGuide;



// WEBPACK FOOTER //
// ./src/phase2/survey/page/nps/children/NpsGuide.js